import React from 'react';
import { View } from 'react-native';

import { VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import style from './ButtonsSectionStyle';

const ButtonsSection = ({
  isPrimaryButtonDisabled,
  theme,
  onPressPrimary,
  onPressSecondary,
  primaryButtonTitle,
  secondaryButtonTitle,
  containerStyle,
}) => {
  return (
    <View style={[style.container, containerStyle]}>
      <VFButton
        disabledStyle={style.disabledButtonStyle(theme)}
        disabledTextStyle={style.disabledTextButtonStyle(theme)}
        title={primaryButtonTitle}
        disabled={isPrimaryButtonDisabled}
        onPress={onPressPrimary}
      />
      <VFButton
        style={style.buttonStyle}
        title={secondaryButtonTitle}
        type="secondary"
        onPress={onPressSecondary}
      />
    </View>
  );
};

ButtonsSection.defaultProps = {
  primaryButtonTitle: 'Review',
  secondaryButtonTitle: 'Cancel',
};

ButtonsSection.propTypes = {
  isPrimaryButtonDisabled: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  onPressPrimary: PropTypes.func,
  onPressSecondary: PropTypes.func,
  primaryButtonTitle: PropTypes.string,
  secondaryButtonTitle: PropTypes.string,
  containerStyle: ViewPropTypes.style,
};
export default ButtonsSection;
